import * as Data$dLeibniz from "../Data.Leibniz/index.js";
import * as Partial from "../Partial/index.js";
const ProofIsPartial = x => x;
const leTotalTotal = {};
const mostPartialTotalTotalTota = {Le0: () => {}, Le1: () => {}};
const lePartial = {};
const mostPartialPartialPartial = {Le0: () => {}, Le1: () => {}};
const mostPartialPartialTotalPa = {Le0: () => {}, Le1: () => {}};
const mostPartialTotalPartialPa = {Le0: () => {}, Le1: () => {}};
const isTotalityTotal = {isTotal: v => true};
const isTotalityPartial = {isTotal: v => false};
const eqProofIsPartial = {eq: v => v1 => true};
const isTotal = dict => dict.isTotal;
const isPartial = Data$dLeibniz.refl;
const absurd = v => Partial._crashWith("You broke the universe!");
export {
  ProofIsPartial,
  absurd,
  eqProofIsPartial,
  isPartial,
  isTotal,
  isTotalityPartial,
  isTotalityTotal,
  lePartial,
  leTotalTotal,
  mostPartialPartialPartial,
  mostPartialPartialTotalPa,
  mostPartialTotalPartialPa,
  mostPartialTotalTotalTota
};
